/**
 * Check if an error indicates that a strategy is still executing
 *
 * @param error - The error object from API query (can be from RTK Query or any error object)
 * @returns true if the error indicates strategy is executing, false otherwise
 *
 * @example
 * const { error } = useGetEngageMapMembersQuery(...);
 * if (isStrategyExecutingError(error)) {
 *   return <StrategyExecutingState />;
 * }
 */
export const isStrategyExecutingError = (error: any): boolean => {
  if (!error) return false;

  const errorDetails = error?.data?.details || '';
  const errorMessage = error?.data?.message || '';
  const executingMessage =
    'This strategy has not finished executing. Please try again later.';

  return (
    errorDetails.includes(executingMessage) ||
    errorMessage.includes(executingMessage)
  );
};

/**
 * Check if multiple errors indicate that a strategy is still executing
 * Returns true if any of the errors indicate strategy execution
 *
 * @param errors - Array of error objects
 * @returns true if any error indicates strategy is executing
 *
 * @example
 * const { error: mapError } = useGetEngageMapMembersQuery(...);
 * const { error: listError } = useGetEngageStrategyListMembersQuery(...);
 * if (isStrategyExecutingErrors([mapError, listError])) {
 *   return <StrategyExecutingState />;
 * }
 */
export const isStrategyExecutingErrors = (errors: any[]): boolean => {
  return errors.some((error) => isStrategyExecutingError(error));
};
